(function (app) {

    app.provider("AuthService", [function () {
        this.$get = ["crmApiGateway", "permissionService", "authTimeoutService", "figAuthSettings", "$window", "baseApiUrl", "$q", "$cookies",
            function (crmApiGateway, permissionService, authTimeoutService, figAuthSettings, $window, baseApiUrl, $q, $cookies) {

                return {
                    login: login,
                    logout: logout,
                    isAuthenticated: isAuthenticated
                };

                function login(redirect) {
                    var url = baseApiUrl + "/Login/Auth0?returnUrl=" + window.encodeURIComponent(window.location.protocol + "//" + window.location.host);
                    if (redirect && (redirect !== "#"))
                        url += window.encodeURIComponent("/" + redirect);
                    window.location.href = url;
                }

                function logout() {
                    permissionService.removeStoredPermissions();
                    window.location.href = baseApiUrl + "/Login/Logout/FigAuth?redirectUri=" + window.encodeURIComponent(window.location.protocol + "//" + window.location.host + "/#/Login?msg=logout");
                }

                function isAuthenticated() {
                    // TODO: set timer for modal
                    var timerCookie = $cookies.get(".timer.advisorCrm");
                    if (!timerCookie) return $q.when(false);
                    var expiration = new Date(timerCookie);
                    if (window.isNaN(expiration.getTime())) return $q.when(false);
                    return $q.when(expiration > new Date());
                }
            }];
    }]);

    app.run(["crmApiGateway", function (api) {
        api.addInterceptor(["AuthService", function (AuthService) {
            return {
                request: function (config) {
                    config.withCredentials = true;
                    return config;
                }
            };
        }]);
    }]);

    app.run(["externalsApiGateway", function (api) {
        api.addInterceptor(["AuthService", function (AuthService) {
            return {
                request: function (config) {
                    config.withCredentials = true;
                    return config;
                }
            };
        }]);
    }]);

    //temporary
    app.run(["AuthService", "crmApiGateway", function (auth, api) { window.auth = auth; window.api = api; }]);

})(window.app); //jshint ignore:line